module.exports = __webpack_public_path__ + "static/img/expired.cbcaad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/expired.png
// module id = 9MUK
// module chunks = 0